import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/payment-order-amount',
      name: 'admin-payment-order-amount',
      component: () => import(/* webpackChunkName: "page-admin-plain-order-management-payment" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "支付"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "订单管理"
                                        },
                                        {
                                                  name: "支付"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
